
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ServiceItemProps } from ".";
import { loading, find } from "store/service";

interface ApiServiceFindByIdInputProps {
    id: number;
}

type ApiServiceFindOutputProps = OutputBaseProps<{ item: ServiceItemProps; }, ApiServiceFindByIdInputProps>

export const apiServiceFindById = async (data: ApiServiceFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiServiceFindOutputProps>(`/api/service/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiServiceFindByCodeInputProps {
    code: string;
}

export const apiServiceFindByCode = async (data: ApiServiceFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiServiceFindOutputProps>(`/api/service/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};